module.exports = __webpack_public_path__ + "static/Arm-528c0bd4fcdf50d2f72c32abcf3bec22.gif";